// @flow

export const emptyObject: {} = Object.freeze({});
